import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FC170 / FC171)
// ============================================================

export interface FC171 {
  fc171_01: string;          // S/C No (FK)
  fc171_02: number;          // Item No (FK)
  fc171_03: number;          // Detail seq no
  fc171_11: number;          // Color quantity
  fc171_112: string;         // Unit
  fc171_12: string | null;   // Process 1 planned date
  fc171_121: string | null;  // Process 1 completed date
  fc171_13: string | null;   // Process 2 planned date
  fc171_131: string | null;  // Process 2 completed date
  fc171_14: string | null;   // Process 3 planned date
  fc171_141: string | null;  // Process 3 completed date
  fc171_15: string | null;   // Process 4 planned date
  fc171_151: string | null;  // Process 4 completed date
  fc171_16: string | null;   // Process 5 planned date
  fc171_161: string | null;  // Process 5 completed date
  fc171_17: string | null;   // Process 6 planned date
  fc171_171: string | null;  // Process 6 completed date
  fc171_18: string | null;   // Process 7 planned date
  fc171_181: string | null;  // Process 7 completed date
  fc171_19: string | null;   // Process 8 planned date
  fc171_191: string | null;  // Process 8 completed date
  fc171_20: number;          // Total amount
  fc171_201: string | null;  // Total amount date
  fc171_21: string;          // Abnormal code 1
  fc171_211: string;         // Abnormal note 1
  fc171_22: string;          // Abnormal code 2
  fc171_221: string;         // Abnormal note 2
  fc171_23: string;          // Abnormal code 3
  fc171_231: string;         // Abnormal note 3
  fc171_24: string;          // Abnormal code 4
  fc171_241: string;         // Abnormal note 4
  fc171_25: string;          // Abnormal code 5
  fc171_251: string;         // Abnormal note 5
  fc171_26: string;          // Abnormal code 6
  fc171_261: string;         // Abnormal note 6
  fc171_27: number;          // Color item code
  fc171_281: string;         // Remark 1
  fc171_282: string;         // Remark 2
  fc171_283: string;         // Remark 3
  fc171_284: string;         // Remark 4
}

export interface FC170 {
  fc170_01: string;          // S/C No
  fc170_02: number;          // Item No
  fc170_11: string;          // Entry person (user ID)
  fc170_12: string | null;   // Entry date
  fc170_13: string;          // Remark
  fc170_21: number;          // Total details count
  fc170_91: string;          // Modify user
  fc170_92: string | null;   // Modify time
  fc170_93: string;          // Create user
  details?: FC171[];
}

export interface ListResponse {
  data: FC170[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Functions
// ============================================================

const BASE = '/api/d214';

export const d214Api = {
  list: async (page = 1, size = 20, keyword?: string): Promise<ListResponse> => {
    const params: Record<string, unknown> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get(BASE, { params });
    return res.data;
  },

  get: async (scNo: string, itemNo: number): Promise<FC170> => {
    const res = await apiClient.get(`${BASE}/${encodeURIComponent(scNo)}/${itemNo}`);
    return res.data;
  },

  create: async (master: Partial<FC170>, details: Partial<FC171>[]): Promise<FC170> => {
    const res = await apiClient.post(BASE, { master, details });
    return res.data;
  },

  update: async (scNo: string, itemNo: number, master: Partial<FC170>, details: Partial<FC171>[]): Promise<FC170> => {
    const res = await apiClient.put(`${BASE}/${encodeURIComponent(scNo)}/${itemNo}`, { master, details });
    return res.data;
  },

  delete: async (scNo: string, itemNo: number): Promise<void> => {
    await apiClient.delete(`${BASE}/${encodeURIComponent(scNo)}/${itemNo}`);
  },
};
